<template>
    <div>
        <vs-table
                :sst="true"
                :max-items="pages"
                :total="data.maxPage"
                :data="data.data"
                class="mb-base"
                stripe
                style="text-align:left; display: block; overflow-x: auto; white-space: nowrap;"
        >
            <template slot="thead" style="text-align:left;">
                <vs-th :key="idx" v-for="(col,idx) in data.columns">{{col.heading}}</vs-th>
            </template>

            <template>
                <vs-tr :key="indextr" v-for="(tr, indextr) in data.data">
                    <vs-td :key="idxx" v-for="(col,idxx) in data.columns" :class="getObjectValue(tr, col.class)">
                      <span v-if="col.data != 'options'">{{getObjectValue(tr, col.data)}}</span>
                      <slot v-else name="options" v-bind:id="tr.id"></slot>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
        <vs-pagination class="pagination pagination-warning" :total="data.maxPage" v-model="page"></vs-pagination>
    </div>
</template>

<script>
    import _ from "lodash";

    export default {
        props: {
            data: Object,
            pages: Number
        },
        data() {
            return {
                page: 1,
            }
        },
        watch: {
          page: function (val) {
            this.$emit('changePage',val);
          }
        },
        methods: {
            getObjectValue(obj, objKey) {
                return _.get(obj, objKey);
            }
        }
    }
</script>
